import { render } from "./FooterArea.vue?vue&type=template&id=a3d66e90&scoped=true"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"

import "./FooterArea.vue?vue&type=style&index=0&id=a3d66e90&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d66e90"]])

export default __exports__